import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {reaction} from 'mobx';
import * as d3 from 'd3';
import isUndefined from 'lodash/isUndefined';
import isNumber from 'lodash/isNumber';
import {TrackPlayStatus} from '../../../constants/enums';
import {getInnerRadius, getOuterRadius} from './studioUtility';
import {MAX_LOOPER_TRACKS} from '../../../constants/constants';

const tau = 2 * Math.PI;
const fillColor = 'rgba(255,255,255,0.3)';

@inject('studioStore')
@observer
class StudioPlayerTrackBackgroundLayer extends Component {
    componentDidMount() {
        const {mobileView, studioStore} = this.props;
        const extraWidth = mobileView && 75;
        this.arc = d3.arc()
            .innerRadius(getInnerRadius(0, extraWidth))
            .outerRadius(getOuterRadius(MAX_LOOPER_TRACKS - 1, extraWidth))
            .startAngle(0)
            .cornerRadius(0);
        this.pathEl = d3.select(this.svgG)
            .append('path')
            .datum({endAngle: 0})
            .attr('class', 'studio-track-bg')
            .attr('fill', fillColor)
            .attr('d', this.arc);
        this.modifiedListener = reaction(
            () => studioStore.leaderTrack.lastModified,
            (lastModified) => {
                this.onTrackChange(lastModified, studioStore.leaderTrack.currentTime);
            }, {}
        );
    }

    componentWillUnmount() {
        this.modifiedListener();
    }

    onTrackChange(lastModified) {
        if (isNumber(lastModified)) {
            this.seekTo(this.props.studioStore.leaderTrack.currentTime, this.props.studioStore.leaderTrack.playStatus);
        }
    }

    handlePlayPause = (playStatus) => {
        if (playStatus === TrackPlayStatus.Playing) {
            this.playAnimation();
        } else if (playStatus === TrackPlayStatus.Paused) {
            this.stopAnimation();
        } else {
            this.resetAnimation();
        }
    };

    playAnimation = () => {
        const {leaderTrack, duration} = this.props.studioStore;
        const {currentTime} = leaderTrack;
        const progress = currentTime / duration;
        this.pathEl.transition()
            .duration((duration - currentTime) * 1000)
            .delay(0)
            .ease(d3.easeLinear)
            .attrTween('d', (d) => {
                const interpolate = d3.interpolate(Math.min(tau * progress), tau);
                return (t) => {
                    d.endAngle = interpolate(t);
                    return this.arc(d);
                };
            }); // .on("end", this.playAnimation);
    };

    resetAnimation = () => {
        d3.interrupt(this.pathEl)
        const progress = this.props.studioStore.leaderTrack.playStatus === TrackPlayStatus.Playing ? 1 : 0;
        this.pathEl.attr('d', (d) => {
            d.endAngle = Math.min(tau, tau * progress);
            return this.arc(d);
        });
    };

    stopAnimation = () => {
        if (this.pathEl) {
            this.pathEl.interrupt();
        }
    };

    seekTo = (seekTo, playStatus) => {
        if (!isUndefined(seekTo)) {
            this.stopAnimation();
            this.pathEl.attr('d', (d) => {
                d.endAngle = Math.min(tau, tau * (seekTo / this.props.studioStore.duration));
                return this.arc(d);
            });
            if (playStatus === TrackPlayStatus.Playing) {
                this.playAnimation();
            }
        }
    };

    setRef = (g) => {
        this.svgG = g;
    };

    render() {
        return (
            <g ref={this.setRef}/>
        );
    }
}

export default StudioPlayerTrackBackgroundLayer;
